import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const GA_MEASUREMENT_ID = 'G-GS79PWJK3S';

if (typeof window !== 'undefined' && !window.gtag) {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  const googleTagScript = document.createElement('script');
  googleTagScript.async = true;
  googleTagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(googleTagScript);

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
const isServiceUnavailable = true;

root.render(
  <React.StrictMode>
    {isServiceUnavailable ? (
      <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '24px' }}>
        <h1>Service Unavailable</h1>
      </main>
    ) : <App />}
  </React.StrictMode>
);
